require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

/*global module*/
var Buffer = require('buffer').Buffer;

module.exports = function toString(obj) {
  if (typeof obj === 'string') return obj;
  if (typeof obj === 'number' || Buffer.isBuffer(obj)) return obj.toString();
  return JSON.stringify(obj);
};